export default __webpack_public_path__ + "static/media/DSC_7365.7738e0a6.jpg";